//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin, toWidget, viewToModelPositionOutsideModelElement, Widget } from "ckeditor5";
import { ResponseCategoryCommand } from "./responseCategoryCommand";
import { PLACEHOLDER_VALUE } from "../ckEditorConstants";

export default class ResponseCategoryEditing extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return [Widget];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "ResponseCategoryEditing";
  }

  init() {
    const editor = this.editor;
    this._setupConfig();
    this._setupSchema();
    this._setupConversions();
    editor.commands.add("responseCategory", new ResponseCategoryCommand(editor));
    editor.editing.mapper.on(
      "viewToModelPosition",
      viewToModelPositionOutsideModelElement(editor.model, (viewElement) =>
        viewElement.hasClass("responseCategory"),
      ),
    );
  }

  _createConversationElement(modelItem, writer, allowPlaceholder) {
    const insertType = modelItem.getAttribute("insertType");
    const categoryId = modelItem.getAttribute("categoryId");
    if (categoryId == PLACEHOLDER_VALUE && !allowPlaceholder) {
      return null;
    }
    const categoryName = modelItem.getAttribute("categoryName");
    const element = writer.createContainerElement("span", {
      class: "categoryinsert",
      "data-akinserttype": insertType,
      "data-akcategory": categoryId,
    });
    const text = writer.createText(categoryName);
    writer.insert(writer.createPositionAt(element, 0), text);
    return element;
  }

  _setupConfig() {
    this.editor.config.define("responseCategory", {
      emptyCategoryName: "Please select a category.",
    });
  }

  _setupConversions() {
    const conversion = this.editor.conversion;
    conversion.for("upcast").elementToElement({
      view: {
        name: "span",
        attributes: ["data-akcategory", "data-akinserttype"],
        classes: ["categoryinsert"],
      },
      model: (viewElement, { writer }) => {
        const insertType = viewElement.getAttribute("data-akinserttype");
        const categoryId = viewElement.getAttribute("data-akcategory");
        const categoryName = viewElement.getChild(0).data;
        return writer.createElement("responseCategory", {
          insertType,
          categoryId,
          categoryName,
        });
      },
    });
    conversion.for("dataDowncast").elementToElement({
      model: "responseCategory",
      view: (modelItem, { writer }) => this._createConversationElement(modelItem, writer),
    });
    conversion.for("editingDowncast").elementToElement({
      model: "responseCategory",
      view: (modelItem, { writer }) => {
        const element = this._createConversationElement(modelItem, writer, true);
        if (!element) {
          return null;
        }
        return toWidget(element, writer);
      },
    });
  }

  _setupSchema() {
    this.editor.model.schema.register("responseCategory", {
      allowWhere: "$text",
      inheritTypesFrom: "$text",
      isObject: true,
      allowAttributes: ["insertType", "categoryId", "categoryName"],
    });
  }
}
